import { useAuth } from "~/store/auth";

export default defineNuxtPlugin({
	name: "init-client",
	hooks: {
		"app:created"() {
			const router = useRouter();
			const auth = useAuth();

			window.appLink = () => {
				const BTAGCOOKIE = useCookie("BTAGCOOKIE");
				const config = useRuntimeConfig();
				const genAppUrl = `${config.public.appLink}` + "?btag=" + BTAGCOOKIE.value;
				window.open(genAppUrl, "_blank");
			};

			window.openModal = (modal: string) => {
				switch (modal.toLocaleLowerCase()) {
					case "login":
						if (!auth.loggedIn) {
							auth.modals.login = true;
						}
						break;

					case "register":
						if (!auth.loggedIn) {
							auth.modals.register = true;
						}
						break;

					case "forgot-password":
						if (!auth.loggedIn) {
							auth.modals.forgotPassword = true;
						}
						break;

					case "deposit":
						router.push("?account=deposit");
						break;

					case "withdraw":
						router.push("?account=withdraw");
						break;

					case "my-bets":
						router.push("?account=my-bets");
						break;

					case "bonus-summary":
						router.push("?account=bonus-summary");
						break;

					case "live-chat":
						router.push("?livechat=true");
						break;

					default:
						break;
				}
			};
		},
	},
});
